var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84,44.52 L84,61.32 C84,65.9591919 80.2391919,69.72 75.6,69.72 L8.4,69.72 C3.7608081,69.72 0,65.9591919 0,61.32 L0,44.52 L8.4,44.52 L8.4,59.22 C8.4,60.2638183 9.16156364,61.1297638 10.1593691,61.2925145 L10.5,61.32 L73.5,61.32 C74.5438183,61.32 75.4097638,60.5584364 75.5725145,59.5606309 L75.6,59.22 L75.6,44.52 L84,44.52 Z",
    id: "box",
    fill: "hsl(82, 100%, 32%)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.435379, 0.000000)",
    stroke: "hsl(82, 100%, 32%)",
    strokeLinecap: "square",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 14.5646212,
    y1: -3.55271368e-15,
    x2: 14.5646212,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.1246212,
    y1: 26.88,
    x2: 22.1246212,
    y2: 47.88,
    transform: "translate(22.124621, 37.380000) rotate(45.000000) translate(-22.124621, -37.380000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.42108547e-14,
    y1: 29.9553788,
    x2: 14.8492422,
    y2: 44.8046211
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.59b3e4e9.svg";
export { ForwardRef as ReactComponent };